import { uniq } from "@welshman/lib";
import { INBOX_RELAYS, RELAYS, normalizeRelayUrl, asDecryptedEvent, readList, getListTags, getRelayTags, getRelayTagValues, } from "@welshman/util";
import { deriveEventsMapped } from "@welshman/store";
import { repository } from "./core.js";
import { load } from "./subscribe.js";
import { collection } from "./collection.js";
export const getRelayUrls = (list) => uniq(getRelayTagValues(getListTags(list)).map(normalizeRelayUrl));
export const getReadRelayUrls = (list) => uniq(getRelayTags(getListTags(list))
    .filter((t) => !t[2] || t[2] === "read")
    .map((t) => normalizeRelayUrl(t[1])));
export const getWriteRelayUrls = (list) => uniq(getRelayTags(getListTags(list))
    .filter((t) => !t[2] || t[2] === "write")
    .map((t) => normalizeRelayUrl(t[1])));
export const relaySelections = deriveEventsMapped(repository, {
    filters: [{ kinds: [RELAYS] }],
    itemToEvent: item => item.event,
    eventToItem: (event) => readList(asDecryptedEvent(event)),
});
export const { indexStore: relaySelectionsByPubkey, deriveItem: deriveRelaySelections, loadItem: loadRelaySelections, } = collection({
    name: "relaySelections",
    store: relaySelections,
    getKey: relaySelections => relaySelections.event.pubkey,
    load: (pubkey, request = {}) => load({ ...request, filters: [{ kinds: [RELAYS], authors: [pubkey] }] }),
});
export const inboxRelaySelections = deriveEventsMapped(repository, {
    filters: [{ kinds: [INBOX_RELAYS] }],
    itemToEvent: item => item.event,
    eventToItem: (event) => readList(asDecryptedEvent(event)),
});
export const { indexStore: inboxRelaySelectionsByPubkey, deriveItem: deriveInboxRelaySelections, loadItem: loadInboxRelaySelections, } = collection({
    name: "inboxRelaySelections",
    store: inboxRelaySelections,
    getKey: inboxRelaySelections => inboxRelaySelections.event.pubkey,
    load: (pubkey, request = {}) => load({ ...request, filters: [{ kinds: [INBOX_RELAYS], authors: [pubkey] }] }),
});
//# sourceMappingURL=relaySelections.js.map